import { Collection } from 'modules/core/lib/mobx-rest'

import PlanningVersion from 'modules/shift_management/store/api/models/PlanningVersion'

class PlanningVersions extends Collection<PlanningVersion> {
  get cacheKey(): string {
    return 'planningVersions'
  }
  model() {
    return PlanningVersion
  }
}

const singleton: PlanningVersions = new PlanningVersions()

export default singleton
